export const BASE_URL = "https://api.dyna.finance";
